import { Controller } from "@hotwired/stimulus"

// Line numbers + scroll sync for XML textarea or readonly <pre>.
export default class extends Controller {
  static targets = ["gutter", "editor"]

  connect() {
    this._syncing = false
    this.refresh()
    this.editorTarget.addEventListener("scroll", () => this.syncGutterFromEditor())
    if (this.gutterTarget) {
      this.gutterTarget.addEventListener("scroll", () => this.syncEditorFromGutter())
    }
  }

  refresh() {
    const text =
      this.editorTarget.tagName === "TEXTAREA"
        ? this.editorTarget.value
        : (this.editorTarget.textContent || "")
    const n = Math.max(1, text.split("\n").length)
    this.gutterTarget.textContent = Array.from({ length: n }, (_, i) => String(i + 1)).join("\n")
  }

  syncGutterFromEditor() {
    if (this._syncing) return
    this._syncing = true
    this.gutterTarget.scrollTop = this.editorTarget.scrollTop
    this._syncing = false
  }

  syncEditorFromGutter() {
    if (this._syncing) return
    this._syncing = true
    this.editorTarget.scrollTop = this.gutterTarget.scrollTop
    this._syncing = false
  }
}

